import { HOST_MANAGEMENT_APIS } from "libs/apis/host-management";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";

const useHostManagement = () => {
  const getCancelEventsTicketsListing = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await HOST_MANAGEMENT_APIS.getCancelEventsTicketsListing(
      queryParams
    );
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: pageNumber + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  const approveCancelEventTicket = async (id: number, body: any = {}) => {
    const response = await HOST_MANAGEMENT_APIS.approveCancelEventTicket(
      id,
      body
    );
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getChatTicketMessages = async (
    id: number,
    setData: Function,
    params?: any
  ) => {
    try {
      const response = await HOST_MANAGEMENT_APIS.getChatTicketMessages(
        id,
        params
      );
      const { status = false, data = {} } = response || {};
      if (status) {
        setData(data);
      }
      return response;
    } catch (error) {
      console.error("Error fetching chat ticket messages:", error);
      return null;
    }
  };

  const postChatTicketMessages = async (id: number, body: any) => {
    try {
      const response = await HOST_MANAGEMENT_APIS.postChatTicketMessages(
        id,
        body
      );
      const { status = false, message = "" } = response || {};
      if (status) {
        // successToaster(message);
      }
      return response;
    } catch (error) {
      console.error("Error posting chat ticket message:", error);
      return null;
    }
  };

  return {
    getCancelEventsTicketsListing,
    approveCancelEventTicket,
    getChatTicketMessages,
    postChatTicketMessages,
  };
};

export default useHostManagement;
